import { THEME_COLORS } from "@jumbo/constants/CustomizerOptions";

const theme_blue = {
    primary:"#007bff",
    primary_text:"#fff",
    secondary:"#d84c80",
    app_header_bg:"#3f51b5",
    sidebar:{
        text:"rgba(0, 0, 0, 0.6)",
        text_hover:"rgba(0, 0, 0, 0.87)",
        nav_active_bg:"#007bff",
        nav_text_active:"#fff",
        nav_hover_bg:"rgb(229, 229, 229)",
    },
    multiPage:{
        text:"rgb(52, 58, 64)",
        text_active:"#fff",
        item_active_bg:"#007bff",
    },
    loader:{
        bg:"#007bff",
        text:"#fff"
    }
}
  
function getTheme(theme){
    if(typeof theme == 'object') return theme; //配置对象，直接使用
    if(!theme) return theme_blue;
    switch(theme){
        case "blue": return theme_blue;
    }
}

export {getTheme};
  